import { Component, OnInit } from '@angular/core';
import { TopicService } from '../topic.service';
import { GeneralComponent } from '../../General/g.component';
import { MessageService } from '../../shared/message.service';

@Component({
  selector: 'app-t-all-exams',
  templateUrl: './t-all-exams.component.html',
  styleUrls: ['../../General/tiles.css', './t-all-exams.component.css']
})
export class TAllExamsComponent extends GeneralComponent {

  allExams:any[] = [];
  constructor(protected topicService: TopicService, private messageService: MessageService) { 
    super(topicService);
    this.allExams = topicService.getAllExams();
  }

  /** saves the changes made in order */
  saveChanges(){
    let index = 1;
    for(let exam of this.allExams){
      exam.id=index;
      index++;
    }
      this.topicService.updateAllExams(this.allExams);
      this.messageService.addAlertWithTimeout(this.get("saveDone"), "success", 5000);
  }

   /** deletes the exercise from the exercise list. Does NOT save 
   * @param {number} index - index of exercise to delete
  */
 deleteExam(index:number):void{
  this.allExams.splice(index, 1)
}


}
